export default function Calculate_ROI() {
    return (
        <section className="w-full py-16 sm:py-20 md:py-28 px-4 bg-white">
            <div className="max-w-6xl mx-auto">
                <div className="bg-gradient-to-br from-blue-50 via-white to-indigo-50 rounded-3xl sm:rounded-[3rem] p-6 sm:p-10 md:p-16 shadow-xl border border-blue-100 relative overflow-hidden">
                    
                    {/* Background Glow */}
                    <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-200 rounded-full blur-3xl opacity-40"></div>
                    <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-indigo-200 rounded-full blur-3xl opacity-40"></div>
                    
                    <div className="relative z-10 flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
                        
                        {/* Left Side - Form */}
                        <div className="w-full lg:w-1/2">
                            <span className="text-blue-600 font-bold tracking-[0.3em] uppercase text-xs mb-4 block">Intelligence Tool</span>
                            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                                Uncover Hidden <br />
                                <span className="text-transparent bg-clip-text bg-sky-500/100">Profit Margins</span>
                            </h2>
                            <p className="text-slate-600 text-base sm:text-lg mb-8 leading-relaxed">
                                Our TOC algorithm identifies bottlenecks in seconds. Input your data to see the immediate impact on your bottom line.
                            </p>

                            <div className="space-y-4">
                                <div>
                                    <label className="text-xs font-bold text-slate-400 uppercase tracking-widest ml-4 mb-1 block">Business Sector</label>
                                    <select className="w-full bg-white border-2 border-slate-100 rounded-2xl px-5 py-3.5 outline-none focus:border-blue-400 transition-all appearance-none cursor-pointer shadow-sm text-slate-700">
                                        <option value="">Select business</option>
                                        <option>Manufacturing</option>
                                        <option>Retail</option>
                                        <option>Distribution</option>
                                        <option>E-commerce</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="text-xs font-bold text-slate-400 uppercase tracking-widest ml-4 mb-1 block">Product Availability (%)</label>
                                    <input type="text" placeholder="e.g. 80" className="w-full bg-white border-2 border-slate-100 rounded-2xl px-5 py-3.5 outline-none focus:border-blue-400 transition-all shadow-sm text-slate-700" />
                                </div>
                                <button className="w-full bg-sky-500/100 text-white py-4 rounded-2xl font-bold text-base sm:text-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5 active:scale-[0.98] shadow-lg">
                                    Calculate Impact
                                </button>
                            </div>
                        </div>

                        {/* Right Side - Coming Soon Card */}
                        <div className="w-full lg:w-1/2">
                            <div className="bg-white/80 backdrop-blur-sm border-2 border-blue-100 rounded-3xl p-8 sm:p-10 md:p-12 text-center shadow-xl">
                                <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-2xl flex items-center justify-center">
                                    <span className="text-4xl">🚀</span>
                                </div>
                                <h3 className="text-2xl sm:text-3xl font-bold text-slate-800 mb-3">Coming Soon</h3>
                                <p className="text-slate-500 mb-6">
                                    We're building something amazing for you.
                                </p>
                                <div className="flex items-center justify-center gap-2 text-sm text-slate-400">
                                    <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                                    <span>Launching in 2027</span>
                                </div>
                                <div className="mt-6 pt-6 border-t border-blue-100">
                                    <p className="text-xs text-slate-400">
                                        Get notified when we launch
                                    </p>
                                    <button className="mt-3 px-6 py-2 bg-slate-100 text-slate-600 font-medium rounded-full text-sm hover:bg-slate-200 transition">
                                        Notify Me
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}